import React from "react";
import ChatBot from "react-simple-chatbot"
import Post from './Post';
import { ThemeProvider } from "styled-components";

function CustomChatbot(props) {
    const config = {
      width: "300px",
      height: "400px",
      floating: true
    };
    const theme = {
        background: "white",
        fontFamily: "Arial, Helvetica, sans-serif",
        headerBgColor: "#00B2B2",
        headerFontColor: "#fff",
        headerFontSize: "25px",
        botBubbleColor: "#00B2B2",
        botFontColor: "#fff",
        userBubbleColor: "#fff",
        userFontColor: "#4c4c4c"
       };
    const steps=[
        {
          id:'q-firstname', 
          message:'What is your first name?', 
          trigger:'firstname',
        },
        {
          id:'firstname', 
          user:true,
          trigger:'q-lastname'
        },
        {
          id:'q-lastname', 
          message:'What is your last name?', 
          trigger:'lastname',
        },
        {
          id:'lastname', 
          user:true,
          trigger:'q-email'
        },
        {
          id:'q-email', 
          message:'Finally. what is you email?', 
          trigger:'email',
        },
        {
          id:'email', 
          user:true,
          trigger:'q-submit'
        },
        {
          id:'q-submit', 
          message:'Do you wish to submit?', 
          trigger:'submit'
        },
        {
          id:'submit', 
          options:[
          {value:'y', label:'Yes', trigger:'end-message'},
          {value:'n', label:'No', trigger:'no-submit'},
          ] 
        },
        {
                id: 'no-submit',
                message:'Your information was not submitted.', 
                end: true,
             },
                  {
                id: 'end-message',
                component: <Post />,
                asMessage: true,
                trigger:'q-firstname'
             },
      ];
    
    return ( <ThemeProvider theme={theme}>
        <ChatBot steps={steps} {...config} />
     </ThemeProvider>     
    )
   }
   export default CustomChatbot;